
import React from "react";
import { useNavigate } from "react-router-dom";

import {
  FaTh,
  FaGift,
  FaHeadset,
  FaUsers,
  FaDesktop,
} from "react-icons/fa";

import LanguageSelector from "./LanguageSelector";
import "./TopBar.css";

const translations = {
  en: { exchange: "Exchange", wallet: "Wallet" },
  fr: { exchange: "Échange", wallet: "Portefeuille" },
  sw: { exchange: "Kubadilisha", wallet: "Pochi" },
  pt: { exchange: "Câmbio", wallet: "Carteira" },
  es: { exchange: "Intercambio", wallet: "Billetera" },
  ar: { exchange: "تبادل", wallet: "المحفظة" },
  zh: { exchange: "兑换", wallet: "钱包" },
  hi: { exchange: "एक्सचेंज", wallet: "वॉलेट" },
  bn: { exchange: "এক্সচেঞ্জ", wallet: "ওয়ালেট" },
  ru: { exchange: "Обмен", wallet: "Кошелёк" },
  de: { exchange: "Tausch", wallet: "Wallet" },
  it: { exchange: "Scambio", wallet: "Portafoglio" },
  nl: { exchange: "Wisselen", wallet: "Portemonnee" },
  tr: { exchange: "Borsa", wallet: "Cüzdan" },
  ja: { exchange: "交換", wallet: "ウォレット" },
  ko: { exchange: "교환", wallet: "지갑" },
  vi: { exchange: "Trao đổi", wallet: "Ví" },
  th: { exchange: "แลกเปลี่ยน", wallet: "กระเป๋าเงิน" },
  id: { exchange: "Penukaran", wallet: "Dompet" },
  ms: { exchange: "Pertukaran", wallet: "Dompet" },
  ur: { exchange: "تبادلہ", wallet: "والیٹ" },
  fa: { exchange: "تبادل", wallet: "کیف پول" },
  ha: { exchange: "Musayar kuɗi", wallet: "Jakar kuɗi" },
  yo: { exchange: "Pààrọ̀", wallet: "Àpamọ́ owó" },
  zu: { exchange: "Ukushintshanisa", wallet: "Isikhwama semali" },
  am: { exchange: "መለዋወጥ", wallet: "የገንዘብ ቦርሳ" },
  so: { exchange: "Sarif", wallet: "Boorsada lacagta" },
  rw: { exchange: "Guhana", wallet: "Umufuka w'amafaranga" },
  lg: { exchange: "Okukyusa", wallet: "Ensawo ya ssente" },
  af: { exchange: "Ruil", wallet: "Beursie" },
};

const getTranslations = () => {
  const language = localStorage.getItem("language") || "en";
  return translations[language] || translations.en;
};

const TopBar = () => {
  const navigate = useNavigate();
  const t = getTranslations();

  return (
    <div className="topbar">
      {/* LEFT - LOGO & ALL PAGES */}
      <div className="topbar-left">
        <button
          type="button"
          className="top-icon-btn"
          onClick={() => navigate("/all-pages")}
          aria-label="All Pages"
        >
          <FaTh className="top-icon" />
        </button>

        <img
          src="/logo512.png"
          alt="Logo"
          className="topbar-logo"
        />
      </div>

      {/* CENTER - USERS, EXCHANGE & WALLET */}
      <div className="topbar-center">
        <button
          type="button"
          className="top-center-icon-btn"
          onClick={() => navigate("/agents")}
          aria-label="Users"
        >
          <FaUsers className="top-icon" />
        </button>

        <button
          type="button"
          className="active-btn"
          onClick={() => navigate("/change-Password")}
        >
          {t.exchange}
        </button>

        <button
          type="button"
          className="wallet-btn"
          onClick={() => navigate("/wallets")}
        >
          {t.wallet}
        </button>
      </div>

      {/* RIGHT - LANGUAGE & NAVIGATION */}
      <div className="topbar-right">
        <div className="topbar-language">
          <LanguageSelector />
        </div>

        <button
          type="button"
          className="top-icon-btn"
          onClick={() => navigate("/customer-care")}
          aria-label="Customer Care"
        >
          <FaHeadset className="top-icon" />
        </button>

        <button
          type="button"
          className="top-icon-btn"
          onClick={() => navigate("/gift")}
          aria-label="Gift"
        >
          <FaGift className="top-icon" />
        </button>

        <button
          type="button"
          className="top-icon-btn"
          onClick={() => navigate("/change-Password")}
          aria-label="Desktop"
        >
          <FaDesktop className="top-icon" />
        </button>
      </div>
    </div>
  );
};

export default TopBar;
